export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title;
};

export const createUrl = () => {
  return `/inspection-errand-setting/create`;
};

export const overviewUrl = () => {
  return `/inspection-errands`;
};

export const detailUrl = () => {
  return `/inspection-errands`;
};
